import React, { ChangeEventHandler } from 'react';

import ValidatorFormGroup from '../../main/validator-form-group';

interface Props {
    availableRmsProviders?: string[];
    label: string;
    disabled?: boolean;
    value: string|undefined;
    onChange: ChangeEventHandler<HTMLSelectElement>;
}

function FieldSelectPmsProvider(props: Readonly<Props>) {
    const selectedItem = props.value;
    const availableProviders = props.availableRmsProviders || [];

    return (
        <ValidatorFormGroup label={props.label} hideErrorLabel>
            <select
                disabled={props.disabled}
                className={'form-control'}
                name={'pms_provider'}
                onChange={props.onChange}
                value={selectedItem}
                required
            >
                {selectedItem && !availableProviders.includes(selectedItem) &&
                    renderOption(selectedItem)}
                {availableProviders.map(renderOption)}
            </select>
        </ValidatorFormGroup>
    );

    function renderOption(pmsProvider: string) {
        return (
            <option key={pmsProvider} value={pmsProvider}>
                {pmsProvider}
            </option>
        );
    }
}

export default FieldSelectPmsProvider;
